import React from 'react';
import {connect} from 'react-redux';
import {bindActionCreators, compose} from 'redux';
import * as articlesActions from '../../actions/articlesActionCreators';
import {Link, withRouter} from 'react-router-dom';
import Layout from '../../layout/Layout';
import constants from '../../constants';
import {useMount} from 'react-use';
import ArticlesList from '../../components/Articles/List';
import SeoTags from '../../routes/SeoTags';

const EventsPage = (props) => {
  const
    collection = props.articlesState.events,
    paginator = {
      ...props.articlesState.paginator,
      onChange: (page, per_page) => {
        props.articlesActions.fetchEvents({
          page,
          per_page
        });
      }
    };

  useMount(() => {
    props.articlesActions.fetchEvents();
  });

  return (
    <Layout
      className='events-page'
      breadcrumbs={[
        {label: 'Новости'}
      ]}
    >
      <SeoTags
        controller_action='events#index'
      />
      <div className='container'>
        <section className='page-content-section'>
          <ArticlesList
            collection={collection}
            linkHelper={constants.ROUTES.REGIONAL_EVENT_PATH}
            paginator={paginator}
          />

        </section>
      </div>
    </Layout>
  );
}

const mapDispatchToProps = (dispatch) => {
    return {
      articlesActions: bindActionCreators(articlesActions, dispatch)
    };
  },

  mapStateToProps = ({articlesState, railsContext, applicationState}) => {
    return {
      applicationState,
      articlesState,
      railsContext
    };
  },

  withConnect = connect(
    mapStateToProps,
    mapDispatchToProps
  );

export default withRouter(compose(withConnect)(EventsPage));
